import { GET_HOME_CARE_ITEM_LIST } from '../constants';

export default (state = {}, action) => {
  switch (action.type) {
    case `${GET_HOME_CARE_ITEM_LIST}_PENDING`:
      return state;
    case `${GET_HOME_CARE_ITEM_LIST}_FULFILLED`: {
      const homeCareItemList = action.payload;
      if (homeCareItemList.error) return state;
      return { ...state, ...homeCareItemList };
    }
    case `${GET_HOME_CARE_ITEM_LIST}_REJECTED`: {
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/homeCareItemList.js